import { Alert } from "@mui/material";
import { Button, SimpleFormProps, useUpdate } from "react-admin";

export const UnlockButton: React.FC<Omit<SimpleFormProps, "children">> = (props) => {
  const [approve, { loading }] = useUpdate('drivers', props.record.id + '/unlock', props.record);
  return <Button label="Unlock" alignIcon="right" color="inherit" onClick={approve} disabled={loading} />;
};

export const LockAlert = (props: any): JSX.Element => {
  return<div>{props?.record?.blocked ? <Alert style={{marginBottom: '40px'}} action={props.button} variant="outlined" severity="error">
        The account is blocked!
  </Alert> : ''}</div>;
}